import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'snakeToSpace',
})
export class SnakeToSpacePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (typeof value === 'string') {
      return value.replace(/_/g, ' ');
    }
    return value;
  }
}
